/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import useModals from '../../../../hooks/useModals'
import {useNavigate} from 'react-router-dom'
import {DELETE, GET} from '../../../../services/api'
import Swal from 'sweetalert2'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {getPlugintypeIdByCode} from '../../../../functions/plugintype'
import useAuth from '../../../../hooks/useAuth'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import getIntegrationsPrint from '../../../../utils/printOrder'
import styles from './index.module.css'
import {Buffer} from 'buffer'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
const qz = require('qz-tray')

type IntegrationType = {
  id: number
  name: string
  type: string
  templateType: string
  typeId: number
}

type IntegrationResponseType = {
  id: number
  name: string
  plugintemplateId: {
    id: number
    name: string
    parameters: string
    plugintypeId: number
    typeIntegration: string
  }
}

const OutrosContent: FC = () => {
  const {showDeleteModal} = useModals()
  const {loginInfo} = useAuth()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [integrations, setIntegrations] = useState<Array<IntegrationType>>([])
  const [id, setId] = useState<number | null>(null)
  const [isPrinting, setIsPrinting] = useState(false)
  const [, setMeta] = useState<MetaType | undefined>(undefined)
  const [modalToShow, setModalToShow] = useState<'print'>('print')
  const [resultPrint, setResultPrint] = useState<{success: boolean; message: string} | null>(null)
  const {showWrapperModal} = useModals()
  const {getIntegrations, getPluginConfigs, metaPluginConfigs} = usePluginsSpace()
  const getIntegrationsOutros = async (take: number = 10, page: number = 1): Promise<void> => {
    try {
      setLoading(true)

      await getIntegrations(true, false)
      const integrationRes = await getPluginConfigs(true, false)
      const newIntegrations: IntegrationType[] = integrationRes.map(
        (pluginconfig: IntegrationResponseType) => {
          return {
            id: pluginconfig.id,
            name: pluginconfig.name,
            type: pluginconfig.plugintemplateId.name,
            typeId: pluginconfig.plugintemplateId.plugintypeId,
            templateType: pluginconfig.plugintemplateId.typeIntegration,
          }
        }
      )
      let integrationsGet: IntegrationType[] = []
      const plugincode = getPlugintypeIdByCode(loginInfo.plugintype)
      newIntegrations.forEach((integration) => {
        if (
          integration.templateType === 'others' &&
          (integration.typeId === plugincode || integration.typeId === 1)
        ) {
          integrationsGet.push(integration)
        }
      })
      setIntegrations(integrationsGet)
      setMeta(metaPluginConfigs)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const deleteIntegration = async () => {
    try {
      setLoading(true)
      const integrationRes = await DELETE(`/pluginconfig/${id}`)
      if (integrationRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Integração deletada',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getIntegrationsOutros())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar integração!',
        }).then(async () => await getIntegrationsOutros())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar integração!',
      }).then(async () => await getIntegrationsOutros())
      console.log(e)
    }
  }

  const connectQZ = () => {
    return new Promise((resolve, reject) => {
      qz.websocket
        .connect()
        .then(() => resolve('Conectado ao QZ Tray'))
        .catch((error: any) => reject(`Erro na conexão com QZ Tray: ${error}`))
    })
  }

  const printTest = async () => {
    setIsPrinting(true)
    setResultPrint(null)
    try {
      const print = await GET('order-printer/order-connection')
      if (print.success === true) {
        const res = await getIntegrationsPrint(loginInfo)
        const dataBuffer = Buffer.from(print.message.data, 'utf8')
        const dataToSend = dataBuffer.toString('utf8')

        await connectQZ()

        qz.printers
          .find(res[0].data[0].content.printer_model)
          .then((printer: any) => {
            const config = qz.configs.create(printer)
            const data = [
              '\x1B\x40', // Inicializa a impressora
              dataToSend,
              '\x1D\x56\x00', // Comando para cortar
            ]
            return qz.print(config, data)
          })
          .then(() => {
            setResultPrint({success: true, message: 'Solicitação enviada com sucesso'})
          })
          .catch((error: any) => {
            setResultPrint({success: false, message: error})
          })
          .finally(() => {
            qz.websocket.disconnect()
          })
      } else {
        setResultPrint({success: false, message: print.message})
      }
    } catch (e) {
      setResultPrint({success: false, message: 'Erro na impressão. Tente novamente.'})
    } finally {
      setIsPrinting(false)
    }
  }

  useEffect(() => {
    getIntegrationsOutros()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`integration.others`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `integration.listed_here_are_the_integrations_along_with_their_respective_actions`
                  )}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`buttons.add_integration`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/pluginconfig/others/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={integrations}
                headers={[
                  {key: i18n.t(`integration.integration_name`), value: 'name', type: 'default'},
                  {key: i18n.t(`integration.type_of_integration`), value: 'type', type: 'default'},
                  {key: i18n.t(`general.actions`), value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => {
                      navigate(`/pluginconfig/others/edit/${item.id}`)
                    },
                    title: `${i18n.t(`general.edit`)} ${i18n.t(`integration.integration`)}`,
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(
                        `${i18n.t(`general.delete`)} ${i18n.t(`integration.integration`)}`
                      )
                      setId(item.id)
                    },
                    title: `${i18n.t(`general.delete`)} ${i18n.t(`integration.integration`)}`,
                  },
                  {
                    icon: 'fa fa-play',
                    action: async (item) => {
                      setModalToShow('print')
                      showWrapperModal('Teste de impressão')
                    },
                    title: 'Teste de impressão',
                    verifyConditionItem: 'type',
                    verifyConditionValue: (value: string) =>
                      ['Impressão de Pedidos'].includes(value),
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
          <ModalDelete confirmAction={() => deleteIntegration()} />
          <ModalWrapper
            confirmAction={() => printTest()}
            noAction={false}
            width={80}
            shouldCloseModal={false}
            noCloseOverlay={isPrinting}
            onCloseAction={() => !isPrinting}
            disableButton={isPrinting}
            textAction={
              modalToShow === 'print' && isPrinting ? (
                <Loading height={20} width={20} />
              ) : modalToShow === 'print' ? (
                'Imprimir'
              ) : (
                ''
              )
            }
          >
            <h1 className='card-label fw-bolder fs-3 mt-8'>Confirmação de Teste de Impressão</h1>
            <span className='mt-6'>
              Você deseja testar a conexão da impressora? Certifique-se de que a impressora está
              conectada e configurada corretamente. Uma janela será exibida solicitando sua
              permissão para a conexão. Clique em "Allow" para continuar.
            </span>

            {resultPrint && (
              <div className={`${resultPrint.success ? styles.successLog : styles.errorLog} mt-8`}>
                <svg
                  width='50'
                  height='50'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M9.6875 2.82031L1.95312 15.5156C1.875 15.6328 1.875 15.7109 1.875 15.8281C1.875 16.1406 2.10938 16.375 2.42188 16.375H17.5391C17.8516 16.375 18.125 16.1406 18.125 15.8281C18.125 15.7109 18.0859 15.6328 18.0078 15.5156L10.2734 2.82031C10.2344 2.70312 10.1172 2.625 10 2.625C9.84375 2.625 9.76562 2.70312 9.6875 2.82031ZM8.08594 1.84375C8.47656 1.17969 9.21875 0.75 10 0.75C10.7422 0.75 11.4844 1.17969 11.875 1.84375L19.6094 14.5391C19.8438 14.9297 20 15.3594 20 15.8281C20 17.1562 18.9062 18.25 17.5391 18.25H2.42188C1.09375 18.25 0 17.1562 0 15.8281C0 15.3594 0.117188 14.9297 0.351562 14.5391L8.08594 1.84375ZM11.25 13.875C11.25 14.5781 10.6641 15.125 10 15.125C9.29688 15.125 8.75 14.5781 8.75 13.875C8.75 13.2109 9.29688 12.625 10 12.625C10.6641 12.625 11.25 13.2109 11.25 13.875ZM10.9375 6.6875V10.4375C10.9375 10.9844 10.5078 11.375 10 11.375C9.45312 11.375 9.0625 10.9844 9.0625 10.4375V6.6875C9.0625 6.17969 9.45312 5.75 10 5.75C10.5078 5.75 10.9375 6.17969 10.9375 6.6875Z'
                    fill={resultPrint.success ? '#67BF5F' : '#EB5353'}
                  />
                </svg>

                <p className='mt-2' style={{color: resultPrint.success ? '#67BF5F' : '#EB5353'}}>
                  {resultPrint.message}
                </p>
              </div>
            )}
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const Outros: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`integration.others`), path: 'pluginconfig/others', isActive: true},
        ]}
      >
        {i18n.t(`integration.others`)}
      </PageTitle>
      <OutrosContent />
    </>
  )
}

export {Outros}
